import {
  createMultiStyleConfigHelpers,
  StyleThemingProps,
} from '@chakra-ui/react'
import { textStyleKeys } from '~/themes/textStyles'
import { useCustomMultiStyleConfig } from '~/utils/chakraUtils'
import { getName } from '~/utils/objectUtils'

import { sharedComponentColorKeys } from './_colors'

const { EmptyDetailView: Colors } = sharedComponentColorKeys

const EmptyDetailViewParts = ['container', 'text'] as const

const helpers = createMultiStyleConfigHelpers(EmptyDetailViewParts)

export const EmptyDetailViewStyle = helpers.defineMultiStyleConfig({
  baseStyle: {
    container: {
      justifyContent: 'center',
      alignItems: 'center',
      boxSize: 'full',
    },
    text: {
      userSelect: 'none',
      color: Colors.Text.Color,
      textAlign: 'center',
      textStyle: textStyleKeys.Display2,
    },
  },
})

export const useEmptyDetailViewStyles = (props?: StyleThemingProps) => {
  return useCustomMultiStyleConfig<typeof EmptyDetailViewParts>(
    getName({ EmptyDetailViewStyle }),
    props,
  )
}
